import { Component, OnInit, HostListener } from '@angular/core';
import { SwiperOptions } from 'swiper';
declare var $ : any;
@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutusComponent implements OnInit {
	public isCollapsed = true;
  config: SwiperOptions = {
    pagination: { 
      el: '.swiper-pagination', 
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 15,
    slidesPerView: 1,
    speed: 500,
    loop: true,
    autoplay: {
      delay: 20000,
    },
    breakpoints: {
      // 0: {
      //     slidesPerView: 2,
      //     spaceBetween: 15,
      // },
      // 640: {
      //     slidesPerView: 2,
      //     spaceBetween: 15,
      // },
      // 768: {
      //     slidesPerView: 3,
      //     spaceBetween: 15,
      // },
      // 1024: {
      //     slidesPerView: 6,
      //     spaceBetween: 15,
      // },
    }, a11y: {
      containerMessage: 'Out team members',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}'
    },
  };  
  team = [];
  shown_team = [];
  pillars = [];

  faqs:any = [];

  width: any = 0;
  height: any = 0;
  constructor() { 
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.team = [{
      id:2,
      name: 'Tanuj Kumar',
      designation: 'Manager (HIS Operations)',
      img: 'assets/img/people/tanuj.jpg'
    }, {      
      id:4,
      name: 'Parvindar Singh Bisht',
      designation: 'General Manager (Warehouse Operations)',
      img: 'assets/img/people/parvinder.jpg'
    }, {      
      id:5,
      name: 'Sunil Chandra',
      designation: 'Manager (Warehouse Operations)',
      img: 'assets/img/people/sunil_chandra.jpg'
    }, {    
      id:51,
      name: 'Love Khari',
      designation: 'Senior Manager - Legal & Finance',
      img: 'assets/img/people/Love.jpg'  
    }, {      
      id:6,
      name: 'Nidhi Kanswal',
      designation: 'Graphic Designer',
      img: 'assets/img/people/nidhi.jpg'
    }, {      
      id:10,
      name: 'Arjunaditya',
      designation: 'Senior Software Engineer',
      img: 'assets/img/people/Arjun.jpg'
    }, {      
      id:11,
      name: 'Keshav Goswami',
      designation: 'Senior Software Engineer',
      img: 'assets/img/people/Keshav-1.jpg'
    }, {
      id:18,
      name: 'Yousuf Ali Khan',
      designation: 'Lead - Orders',
      img: 'assets/img/people/yousuf.jpg'
    }, {      
      id:20,
      name: 'Shivani Agarwal',
      designation: 'Lead - Dispatch',
      img: 'assets/img/people/shivani_a.jpg'
    }, {      
      id:19,
      name: 'Saurabh Mani',
      designation: 'Lead - Inwarding & Inventory',
      img: 'assets/img/people/saurabh.jpg'
    }, {      
      id:23,
      name: 'Ankit Rajpoot',
      designation: 'Lead - Inwarding & Inventory',
      img: 'assets/img/people/ankit-2.jpg'
    }, {
      id:30,
      name: 'Narendra Singh',
      designation: 'Lead - Data & Nomenclature',
      img: 'assets/img/people/negi.jpg'
    }, {      
      id:14,
      name: 'Himanshu Raghuvanshi',
      designation: 'Senior Executive - HIS Operations',
      img: 'assets/img/people/himanshu.jpg'
    }, {      
      id:21,
      name: 'Raj Kumar',
      designation: 'Senior Executive - Warehouse Operations',
      img: 'assets/img/people/raj_kumar.jpg'
    }, {      
      id:27,
      name: 'Abhishek Rajput',
      designation: 'Senior Executive - Warehouse Operations',
      img: 'assets/img/people/abhishek_rajput.jpg'
    }, {
      id:28,
      name: 'Sonu Lal',
      designation: 'Senior Executive - Warehouse Operations',
      img: 'assets/img/people/sonu.jpg'
    }, {      
      id:24,
      name: 'Amresh Kumar',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/Amresh.jpg'
    }, {      
      id:25,
      name: 'Sandeep Kumar Yadav',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/sandeep.jpg'
    }, {
      id:41,
      name: 'Ramvir Singh',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/Ramvir.jpg'
    }, {
      id:42,
      name: 'Sonu Mehra',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/Sonu mehra.jpg'
    }, {
      id:43,
      name: 'Aasif Ali',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/Aashif.jpg'
    }, {
      id:44,
      name: 'Pramod Yadav',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/Pramod.jpg'
    }, {
      id:45,
      name: 'Shubham',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/Shubham.jpg'
    }, {
      id:47,
      name: 'Karan Singh',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/Karan.jpg'
    }, {
      id:50,
      name: 'Satyendra Kumar',
      designation: 'Executive - Warehouse Operations',
      img: 'assets/img/people/Satyendra.jpg'
    }, {
      id:39,
      name: 'Anshu Yadav',
      designation: 'Orders Executive',
      img: 'assets/img/people/Anshu.jpg'
    }, {
      id:52,
      name: 'Punit Bhati',
      designation: 'Orders Executive',
      img: 'assets/img/people/Punit.jpg'
    }, {
      id:46,
      name: 'Praful Kumar',
      designation: 'Executive - HIS Operations',
      img: 'assets/img/people/Praful.jpg'
    }, {
      id:40,
      name: 'Sachin Mourya',
      designation: 'Executive - HIS Operations',
      img: 'assets/img/people/Sachin.jpg'
    }, {      
      id:33,
      name: 'Krishan Kant',
      designation: 'Office Executive',
      img: 'assets/img/people/krishan kant.jpg'
    }, {      
      id:36,
      name: 'Sanjeev Kumar',
      designation: 'Delivery Executive',
      img: 'assets/img/people/Sanjeev.jpg'
    }, {      
      id:37,
      name: 'Arman Ali',
      designation: 'Delivery Executive',
      img: 'assets/img/people/arman.jpg'
    }, {
      id:38,
      name: 'Mahesh',
      designation: 'Delivery Executive',
      img: 'assets/img/people/Mahesh.jpg'
    }, {
      id:48,
      name: 'Manish Kumar',
      designation: 'Delivery Executive',
      img: 'assets/img/people/Manish.jpg'
    }, {
      id:53,
      name: 'Tushar Garg',
      designation: 'Accounts Executive',
      img: 'assets/img/people/Tushar.jpg'
    }];

    this.pillars = [{
      id: 1,
      name: 'Dr. Ashish Sabharwal',
      designation: 'Director - Strategy',
      img: 'assets/img/people/dr_ashish.jpeg'
    } , {
      id: 2,
      name: 'Nipun Taneja',
      designation: 'Director - Sales',
      img: 'assets/img/people/nipun.png'
    }, {
      id: 3,
      name: 'Shashwat Mishra',
      designation: 'General Manager - Supply Chain Operations',
      img: 'assets/img/people/shashwat.jpeg'
    }, {
      id: 4,
      name: 'Ritik Singh',
      designation: 'Senior AVP - Sales',
      img: 'assets/img/people/ritik.jpg'
    }, {
      id: 5,
      name: 'Ankit Sharma',
      designation: 'Senior AVP - HIS Operations',
      img: 'assets/img/people/ankit.jpg'
    }];

    this.faqs = [{
      id: 1,
      question: 'Is NuvertOS suitable for all healthcare providers?',
      answer: 'Yes, NuvertOS is suitable for all healthcare providers based on their specific needs and requirements.',
      collapse: false
    }, {
      id: 2,
      question: 'How do I book a demo or trial?',
      answer: 'You can schedule an appointment by sending your request to us at +91 9711201611',
      collapse: true
    }, {
      id: 3,
      question: 'Are NuvertOS training sessions available?',
      answer: 'Yes, we provides training to all users.',
      collapse: true
    }, {
      id: 4,
      question: 'Is there any particular knowledge required to use NuvertOS?',
      answer: 'No specific requirements are necessary.',
      collapse: true
    }, {
      id: 5,
      question: 'What is the maximum number of users I can add?',
      answer: 'Unlimited!',
      collapse: true
    }, {
      id: 6,
      question: 'Is the database secure and safe?',
      answer: 'To ensure your data is secure, we look above and  beyond the industry standards. We adhere to recognized security patterns for encryption, hardening, authentication, and authorization without sacrificing security or privacy.',
      collapse: true
    }, {
      id: 7,
      question: 'What type of hardware setup is necessary?',
      answer: 'All you require is an internet connection.',
      collapse: true
    }, {
      id: 8,
      question: 'Where is your setup or location?',
      answer: 'Our physical office is located in Noida, but our services are accessible nationwide. We also offer in-person training and assistance to users at their respective locations.',
      collapse: true
    }, {
      id: 9,
      question: 'Can I manage users and access controls?',
      answer: 'Yes, you can.',
      collapse: true
    }, {
      id: 10,
      question: 'How do you handle post-sale service concerns from customers?',
      answer: 'Our dedicated account manager will personally visit you to address your queries promptly and provide on-the-spot resolutions.',
      collapse: true
    }, {
      id: 11,
      question: 'In what way do you offer training?',
      answer: 'Both Offline and Online.',
      collapse: true
    }, {
      id: 12,
      question: 'What is the process for backing up our data?',
      answer: 'We have dual data backup on cloud servers.',
      collapse: true
    }]
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.splitTeam();
  }

  ngOnInit() {
    this.insertEmpty();
  }

  openDemo(){
    $('#free-demo').modal('show');
    $('#enquiry-header').text('Demo Request');
  }

  insertEmpty(){
    if(this.width > 767){
      let _interval = 5;
      let offset = 0;
      let i = 0;
      let member = {
        id: 0,
        name: 'You could be next!',
        designation: '',
        img: 'assets/img/question_mark.svg'
      }
      let _team = this.team;
      while(i < _team.length/6){
        _team.splice((_interval + offset), 0, member);
        i++;
        offset+= 6;

      }
      this.team = _team
    }
    this.splitTeam();
  }

  splitTeam(){
    this.shown_team = [];
    let _split_by = 0;

    if(this.width <= 767){
      _split_by = 2;
    } else if(this.width >= 768 && this.width <= 991){
      _split_by = 3;
    } else {
      _split_by = 6;
    } 

    for (let i = 0; i < this.team.length; i += _split_by) {
      this.shown_team.push(this.team.slice(i, i + _split_by));
    }
  }
}
